import { Shield } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const GuaranteeSection = () => {
  return (
    <section className="py-12 relative" id="guarantee">
      <div className="container px-4 mx-auto">
        <div className="max-w-2xl mx-auto text-center">
          <div className="w-14 h-14 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto mb-5">
            <Shield className="w-7 h-7 text-primary" />
          </div>
          <h2 className="font-display text-2xl sm:text-3xl md:text-4xl font-bold mb-3 text-foreground">
            Гарантия <span className="text-gradient-primary">качества</span>
          </h2>
          <p className="text-muted-foreground text-base mb-8 leading-relaxed">
            Послушайте бесплатное демо перед покупкой. Не устроит — попробуйте другой жанр или стиль бесплатно.
          </p>
          <div className="grid grid-cols-3 gap-4 mb-8">
            <div className="p-4 rounded-xl bg-card border border-border">
              <p className="font-display text-xl font-bold text-gradient-primary">12 847+</p>
              <p className="text-muted-foreground text-xs mt-1">хитов создано</p>
            </div>
            <div className="p-4 rounded-xl bg-card border border-border">
              <p className="font-display text-xl font-bold text-gradient-primary">4.8 ⭐</p>
              <p className="text-muted-foreground text-xs mt-1">средняя оценка</p>
            </div>
            <div className="p-4 rounded-xl bg-card border border-border">
              <p className="font-display text-xl font-bold text-gradient-primary">12+</p>
              <p className="text-muted-foreground text-xs mt-1">жанров</p>
            </div>
          </div>
          <Button size="lg" className="shadow-soft" asChild>
            <Link to="/create">
              🔥 Создать хит бесплатно
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default GuaranteeSection;
